import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { interval, Subject, takeUntil } from 'rxjs';
import axios from 'src/app/Service/axios';
import Chart from 'chart.js/auto';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-bcm',
  templateUrl: './bcm.component.html',
  styleUrls: ['./bcm.component.css'],
  providers: [DatePipe]
})

export class BcmComponent implements OnInit {
  overviewData;
  overviewUpdatedTime;
  fanActiveStatus = 0;
  speed = 0;
  rpm = 0;

  dashboardStats = [
    {
      label: 'موقعیت دنده',
      keyValue: 'AcctualGearPostion',
      prefix: ''
    },
    {
      label: 'کیلومتر فعلی',
      keyValue: 'TotalMileageofODO',
      prefix: ''
    },
    {
      label: 'دمای محیط',
      keyValue: 'AmbientTemp',
      prefix: ''
    }
  ]

  engineStats = [
    {
      label: 'وضعیت خودرو',
      keyValue: 'VehickeStatus',
      prefix: '',
      helper: {
        0: 'خاموش',
        1: 'فعال'
      }

    },
    {
      label: 'سوئیچ',
      keyValue: 'KeyOnSignal',
      prefix: '',
      helper: {
        0: 'بسته',
        1: 'باز'
      }

    },
    {
      label: 'دمای ترمز سمت چپ',
      keyValue: 'LeftBrakeTemp',
      prefix: '°C'
    },
    {
      label: 'دمای ترمز سمت راست',
      keyValue: 'RightBrakeTemp',
      prefix: '°C'
    },
    {
      label: 'سرعت واقعی موتور الکتریکی',
      keyValue: 'MotorActualSpeed',
      prefix: ''
    },
    {
      label: 'سرعت واقعی موتور + گشتاور درخواست‌شده ',
      keyValue: 'MotorTorqueRequest',
      prefix: ''
    }
  ]

  batteryStats = [
    {
      label: 'حداکثر ولتاژ سلول باتری',
      keyValue: 'MaxBatteryCellVoltage',
      prefix: 'V'
    },
    {
      label: 'وضعیت سلامت باتری (SOH)',
      keyValue: 'BatteryStatusOfHealth',
      prefix: '%'
    },
    {
      label: 'اطلاعات خطای باتری / وضعیت خطاهای BMS',
      keyValue: 'BatteryFaultInfo',
      prefix: ''
    },
    {
      label: 'ولتاژ باتری کمکی (۱۲ ولت)',
      keyValue: 'SmallBaterryVol',
      prefix: 'V'
    },
    {
      label: 'مجموع ولتاژ تمام سلول‌ها',
      keyValue: 'TotalBatteryVoltage',
      prefix: 'V'
    },
    {
      label: 'وضعیت فعلی فن در سیستم حرارتی باتری',
      keyValue: 'TMS_fanoperatingState',
      prefix: '',
      helper: {
        0: 'خاموش',
        1: 'روشن'
      }

    },
    {
      label: 'دمای سطح اواپراتور',
      keyValue: 'EvaperatorTemp',
      prefix: '°C'
    },
    {
      label: 'درصد شارژ باتری (SOC) ',
      keyValue: 'DisplaySOC',
      prefix: '%'
    },
    {
      label: 'جریان دشارژ باتری',
      keyValue: 'DischargeCurrent',
      prefix: ''
    },
    {
      label: 'گرم‌کن باتری ',
      keyValue: 'BatteryInnerHeatnigActivation',
      prefix: '',
      helper: {
        0: 'فعال',
        1: 'غیرفعال'
      }

    },
    {
      label: 'دمای مایع خنک کننده باتری‌ها',
      keyValue: 'BatteryWaterInletTemp',
      prefix: '°C'
    },
    {
      label: 'حداقل دمای ثبت‌شده بین سلول‌های باتری',
      keyValue: 'BatteryTempMin',
      prefix: '°C'
    },
    {
      label: 'حداکثر دمای ثبت‌شده بین سلول‌های باتری',
      keyValue: 'BatteryTempMax',
      prefix: '°C'
    },
    {
      label: 'ولتاژ کل باتری‌ها',
      keyValue: 'BatteryPackVoltage',
      prefix: 'V'
    },
    {
      label: 'جریان کل باتری‌ها',
      keyValue: 'BatteryPackVolcurrent',
      prefix: 'V'
    }
  ]

  vehicleChargeStats = [
    {
      label: 'جریان خروجی مبدل DC-DC',
      keyValue: 'DCDCoutputCurrent',
      prefix: 'V'
    },
    {
      label: 'ولتاژ خروجی مبدل DC-DC',
      keyValue: 'DCDCoutputVoltage',
      prefix: 'V'
    },
    {
      label: 'دمای شارژ',
      keyValue: 'ChargerTemperature',
      prefix: '°C'
    },
    {
      label: 'ولتاژ لحظه‌ای شارژر',
      keyValue: 'ChargerRealtimeChargingVoltage',
      prefix: 'V'
    },
    {
      label: 'جریان لحظه ای شارژ',
      keyValue: 'ChargerRealtimeChargingCurrent',
      prefix: ''
    },
    {
      label: 'جریان ورودی در حین شارژ',
      keyValue: 'ChargeCurrent',
      prefix: ''
    }
  ]

  mdl_Search: FormGroup = this.formBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('Session')!)),

    strUnitID: new FormControl(),

  });

  private destroy$ = new Subject<void>();

  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  chart: Chart;

  @ViewChild('speedNeedle') speedNeedle: ElementRef<HTMLElement>;
  @ViewChild('rpmNeedle') rpmNeedle: ElementRef<HTMLElement>;

  constructor(
    private el: ElementRef,
    private _tooltip: NotificationService,
    private router: Router,
    public _otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit() {
    this.mdl_Search.patchValue({
      strUnitID: this.route.parent?.parent?.snapshot?.params['id'] ?? '',
    });

    interval(15000).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.fetchOverview(false);
    })
  }

  ngOnDestroy() {
    this.stopTimer();
    this.chart?.destroy();
  }

  stopTimer() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {

    const labels = Array.from({ length: 50 }, (_, i) => i + 1);
    const data = Array.from({ length: 50 }, (_, i) => Math.round(50 + i * 1.5 + (Math.random() * 10 - 5)));

    this.chart = new Chart(this.canvas.nativeElement, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          data,
          borderColor: '#00ffff',
          fill: true,
          backgroundColor: '#00ffff10',
          tension: 0.4,
        }]
      },
      options: {
        responsive: true,
        scales: {
          x: {
            ticks: {
              color: '#ffffffa9'
            },
            grid: {
              color: '#ffffff10',
              borderColor: '#ffffff60',
              borderWidth: 1
            }
          },
          y: {
            ticks: {
              color: '#ffffffa9'
            },
            grid: {
              color: '#ffffff10',
              borderColor: '#ffffff60',
              borderWidth: 1
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
        }
      }
    });

    this.fetchOverview();


  };

  async fetchOverview(showSpinner: boolean = true) {

    if (showSpinner) {
      this._otherService.Showspinner();
    }

    let res = JSON.parse((await axios.post(`CAN_LastValues`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;

    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.overviewData = this.buildNameValueMap(res);
    this.overviewUpdatedTime = this.buildNameTimeMap(res);

    this.speed = this.overviewData?.VehcleSpeed ?? 0;
    this.setSpeed(this.speed);

    this.rpm = this.overviewData?.MotorActualSpeed ?? 0;
    this.setRpm(this.rpm);

  };

  buildNameValueMap(data: any[]): object {
    const transformedObject = data.reduce((acc, item) => {
      const key = item.strEnglishName.trim();
      const value = item.fValue;
      if (typeof value === "number") {
        acc[key] = Number.isInteger(value) ? value : Math.floor(value);
      } else {
        acc[key] = value;
      }
      return acc;
    }, {} as { [key: string]: any });

    return transformedObject;
  }

  buildNameTimeMap(data: any[]): object {
    const transformedObject = data.reduce((acc, item) => {
      const key = item.strEnglishName.trim();
      const time = item.strDateTime;
      acc[key] = time;
      return acc;
    }, {} as { [key: string]: any });

    return transformedObject
  }

  getBadgeClass(state: number | boolean): string {

    if (typeof (state) == 'number' && state > 1) {
      return 'app-badge app-badge-success';
    }

    if (typeof (state) == 'string') {
      return 'app-badge app-badge-state';
    }

    switch (state) {
      case 0:
      case false:
        return 'app-badge app-badge-error';
      case 1:
      case true:
        return 'app-badge app-badge-success';
      case -1:
      default:
        return 'app-badge app-badge-state';
    }

  }

  getBoardClass(state: number | boolean | unknown, item?): string {

    if (item?.helper) {
      state = this.resolveValue(item);
    }

    if (typeof (state) == 'number' && state == -1) {
      return '-icon';
    }

    switch (state) {
      case 0:
        return '-icon';
      case false:
        return '-icon';
      case 1:
        return '-icon active';
      case true:
        return '-icon active';
      case -1:
        return '-icon';
      case -100:
        return '-icon';
      case undefined:
        return '-icon';
      default:
        return '-icon active';
    }

  }

  getIconStateClass(state: number): string {
    if (state >= 0) {
      return '-icon active';
    } else {
      return '-icon unknwon';
    }
  }

  getBadgeStatus(state: number | boolean): string {
    const normalizedState = (typeof state === 'number' && state > 1) ? 1 : state;

    switch (normalizedState) {
      case 0:
      case false:
        return 'خاموش';
      case 1:
      case true:
        return 'روشن';
      case -1:
      default:
        return 'نامشخص';
    }
  }

  getUpdatedTime(englishName: string): string {
    if (!englishName || !this.overviewUpdatedTime) {
      return '';
    }

    const rawDate = this.overviewUpdatedTime[englishName];
    if (!rawDate) {
      return '';
    }
    
    const formatted = this.datePipe.transform(rawDate, 'HH:mm - yyyy/MM/dd');

    return formatted ?? '';

  }

  setSpeed(speed: number) {

    const minAngle = -63;
    const maxAngle = 163;
    const maxSpeed = 180;

    const angle = minAngle + (speed / maxSpeed) * (maxAngle - minAngle);
    this.speedNeedle.nativeElement.style.transform = `rotate(${angle}deg)`;

  };

  setRpm(rpm: number) {
    const minAngle = -71;
    const maxAngle = 171;
    const maxRpm = 8000;

    const angle = minAngle + (rpm / maxRpm) * (maxAngle - minAngle);
    this.rpmNeedle.nativeElement.style.transform = `rotate(${angle}deg)`;
  };

  resolveValue(item): string {
    if (!this.overviewData) return;

    const value = this.overviewData?.[item.keyValue];
    return item.helper?.[value] ?? value;
  }


}